import { StaffTicket, UpdateStaffTicketRequest } from "@signalist/shared-types";

/** The API's code for an assignee who does not pass `canBeAssignee` (PREC-3934 decision 8). */
export const TICKET_ASSIGNEE_NOT_STAFF = "TICKET_ASSIGNEE_NOT_STAFF";

/**
 * Does the PATCH change anything? The shared Dropdown re-selects its value from an effect, so a
 * rail that PATCHed on every "select" would write on every render; and a no-op PATCH is a wasted
 * round-trip the API answers with the unchanged ticket anyway.
 */
export const isNoOpTriage = (ticket: StaffTicket, fields: UpdateStaffTicketRequest): boolean =>
	(fields.status === undefined || fields.status === ticket.status) &&
	(fields.assigneeUserId === undefined || fields.assigneeUserId === ticket.assigneeUserId) &&
	(fields.priority === undefined || fields.priority === ticket.priority) &&
	(fields.category === undefined || fields.category === ticket.category);

export type TriageFailure = "ASSIGNEE_NOT_STAFF" | "FAILED";

/** 400 TICKET_ASSIGNEE_NOT_STAFF gets its own message; everything else is the generic one. */
export const triageFailure = (error: unknown): TriageFailure =>
	(error as { data?: { message?: unknown } } | null | undefined)?.data?.message ===
	TICKET_ASSIGNEE_NOT_STAFF
		? "ASSIGNEE_NOT_STAFF"
		: "FAILED";
